// extracted by mini-css-extract-plugin
export default {"tab":"zHQBqeOTk1","tab-item":"cQk92m9td1","tabItem":"cQk92m9td1","tab-item-narrow":"Cp7M4-6Z5Y","tabItemNarrow":"Cp7M4-6Z5Y","tab-item-disabled":"BLPzDrQ1hD","tabItemDisabled":"BLPzDrQ1hD","tab-item-default":"kySB8GoIAc","tabItemDefault":"kySB8GoIAc","tab-item-active":"m-X8ojy2hn","tabItemActive":"m-X8ojy2hn"};
    if(module.hot) {
      // 1650538050033
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  